import { DatePipe, NgClass } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';

import { OverviewModel, TrialModel, TrialStatus } from '../overview-model';
import { AppStringsPipe } from '../../shared/pipes/appstrings.pipe';
import { AdminService } from '../admin.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

const data: OverviewModel[] = [
  { id: 1, trialNumber: 1380, trialStatus: TrialStatus.Created},
  { id: 2, trialNumber: 1785, insertionDate: new Date(2024, 9, 16), trialStatus: TrialStatus.Pending},
  { id: 3, trialNumber: 1608, insertionDate: new Date(2023, 5, 10), endDate: new Date(2023, 8, 23), trialStatus: TrialStatus.Completed},
];

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [ RouterModule, MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule, NgClass, DatePipe, AppStringsPipe ],
  templateUrl: './admin.component.html',
  // styleUrl: './admin.component.scss',
  providers: [AdminService]
})

export class AdminComponent implements AfterViewInit, OnInit {

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  protected displayedColumns: ReadonlyArray<string> = ['trialNumber', 'insertionDate', 'endDate'];
  protected dataSource: MatTableDataSource<OverviewModel>;
  protected dataTest$: Observable<TrialModel[]> | undefined;
  protected attempt$: Observable<string> | undefined;

  constructor(
    private adminService: AdminService,
    private router: Router,
    private httpClient: HttpClient
  ) {
    this.dataSource = new MatTableDataSource(data);
  }

  ngOnInit(): void {
    // this.attempt$ = this.adminService.attemptEndpoint();
    this.adminService.attemptEndpoint();
    const response = this.httpClient.get("https://localhost.segestest.dk:5292/api/admin/isalive_anon");
    response.subscribe((data) => {
      console.log("Response: ", data);
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'trialNumber':
          return item.trialNumber;

        case 'insertionDate':
          return item.insertionDate?.toString() ?? '';

        case 'endDate':
            return item.endDate?.toString() ?? '';

        default:
          throw new Error(`Unknown property: ${property}`);
      }
    };
    this.dataTest$ = this.adminService.getTrials();
    this.attempt$ = this.adminService.attemptEndpoint();
    this.attempt$.subscribe( (value) => {
      console.log('Attempt endpoint response: ' + value);
    })
    console.log(this.dataTest$);
  }

  uploadTrialInsertion(){
    console.log('button clicked');
  }

  isCompleted(date: Date) : boolean {
    const now = new Date();
    return date < now;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    if (this.dataSource !== null) {
      this.dataSource.filter = filterValue.trim().toLowerCase();

      if (this.dataSource?.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  async rowClick(id: string) {
    console.log('row clicked: ' + id);
    await this.router.navigate([`/admin/edit-trial`]);

    // console.log('row clicked: ' + id);
    // await this.router.navigate([`/admin/edit-trial/${id}`]);
    // When data with ids, change to:
    // await this.router.navigate([`/admin/edit-trial/${id}`]);
  }
}
